import DefaultState from "./state";
const initialState = { ...DefaultState };

const SiniestroEmpresaReducer = (state = DefaultState, action) => {
  switch (action.type) {
    case "RESET_STATE_SINIESTRO_EMPRESA": {
      return Object.assign({}, state, initialState);
    }
    case "LOADING_SINIESTRO_EMPRESA": {
      return Object.assign({}, state, {
        isLoading: action.isLoading,
      });
    }
    case "LOADING_SINIESTRO_DOWNLOAD_EXCEL": {
      return Object.assign({}, state, {
        isDownloadLoading: action.isDownloadLoading,
      });
    }
    case "SET_SINIESTRO": {
      return Object.assign({}, state, {
        selectedSiniestro: action.siniestro,
      });
    }
    case "VIEW_DOCUMENTS": {
      return Object.assign({}, state, {
        viewDocument: action.view,
      });
    }
    case "SET_SINIESTRO_EMPRESA_DETAILS": {
      return { ...state, ...action.details };
    }
    case "SET_SINIESTROS_EMPRESA": {
      return Object.assign({}, state, {
        siniestros: action.siniestros,
        totalSiniestros: action.total,
      });
    }
    case "RESET_DETALLE_SINIESTRO_EMPRESA": {
      return Object.assign({}, state, {
        denuncias: [],
        prestacionesEconomicas: [],
        evaluacionesIncapa: [],
        atencionesMedicas: [],
        periodosReposo: [],
      });
    }
    case "SET_SINIESTROS_EMPRESA_CON_FILTROS": {
      return Object.assign({}, state, {
        siniestrosWithFilter: action.siniestrosWithFilter,
      });
    }

    case "SET_SINIESTRO_FILTERS": {
      return Object.assign({}, state, {
        filtrosSiniestros: action.filtros,
      });
    }
    case "SET_DOCUMENT_SINIESTRO": {
      return Object.assign({}, state, {
        listDocuments: action.listDocuments,
      });
    }
    case "SET_SHOW_DATA_EMPRESA": {
      return { ...state, ...action.details };
    }
    case "SUCCESS_TAG_MANAGER": {
      return { ...state, ...action.success };
    }
    default:
      return state;
  }
};

export default SiniestroEmpresaReducer;
